<template>
  <div class="houseSuperiority">
     <div class="house_intro_remark">
    <div class="house_intro textarea_info">
      <p class="title">
        房源优势
      </p>
      <p class="con" :title="HousesData.houseDescription ? HousesData.houseDescription : '未填写'">
         
         <span class="conCenter">
          <!-- {{ HousesData.houseDescription ? HousesData.houseDescription : '未填写' }} -->
              <pre>{{ HousesData.houseDescription ? HousesData.houseDescription : '未填写' }}</pre>
         </span>
      </p>
    </div>
      <div class="house_intro textarea_info">
      <p class="title">
        可经营行业
      </p>
      <div class="con" >
          <div class="conCenter labelTag">
            <div v-if="!(HousesData.industryCategoryVoList&&HousesData.industryCategoryVoList.length>0)">未填写</div>
              <div v-for="(item, index) in HousesData.industryCategoryVoList" :key="'class_' + index" :class="HousesData.industryCategoryVoList.length>1&&(index!==HousesData.industryCategoryVoList.length-1) ? 'div':''" style="padding:10px 0">
                    <div v-if="item&&item.industryCategoryName">
                      <a-tag color="#f50" >{{ item&&item.industryCategoryName }}</a-tag>
                    </div>
                  <div>
                    <a-tag v-for="(sub, subIdx) in item&&item.industryCategoryVoList" :key="'bub_' + subIdx">{{ sub&&sub.industryCategoryName }}</a-tag>
                  </div>
            </div>
          </div>
      </div>
    </div>

    <div class="house_remark textarea_info">
      <p class="title">备注</p>
      <!-- <span style="font-size: 12px; color: var(--ThemeColor)">(滚动或放于内容上查看更多)</span> -->
      <p class="con" :title="HousesData.otherInfo ? HousesData.otherInfo : '暂无备注'">
         <span class="conCenter">
          <pre>{{ HousesData.otherInfo ? HousesData.otherInfo : '暂无备注' }}</pre>
        </span>
      </p>
    </div>
    </div>
  </div>
</template>
<script>
import '../assets/font/iconfont.css'
import 'swiper/css/swiper.css'
export default {
  data() {
    return {
      HousesData: {},
    }
  },
  props: {
    HousesDatas: {
      type: Object,
      default: () => {},
    },
  },
  watch: {
    HousesDatas: {
      handler: function (newVal, oldVal) {
        this.HousesData = newVal
      },
    },
    immediate: true,
    deep: true,
  },
}
</script>
<style lang="less" scoped>
pre{ 
  white-space:pre-wrap; /* css3.0 */ 
  white-space:-moz-pre-wrap; /* Firefox */ 
  font-family:apple-system, BlinkMacSystemFont, 'Segoe UI', 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', 'Helvetica Neue', Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol';
  white-space:-pre-wrap; /* Opera 4-6 */ 
  white-space:-o-pre-wrap; /* Opera 7 */ 
  word-wrap:break-word; /* Internet Explorer 5.5+ */ 
} 
.labelTag .div{
  border-bottom: 1px dashed #d9d9d9;
  padding-bottom:5px;
}
.labelTag .div:nth-child(1){
  padding-top:0!important;
}
.houseSuperiority{
  .house_intro_remark {
    width: 100%;
    height: auto;
    display: flex;
    justify-content: space-around;
    .textarea_info {
      width: 32%;
      height: auto;
      .title {
        color: #222;
        font-size: 16px;
        font-weight: 700;
        cursor: pointer;
      }
      .con {
        width: 96%;
        height: 240px;
        padding: 10px 2%;
        line-height: 30px;
        // border:1px solid var(--ThemeColor);
        border-radius: 8px;
        -webkit-border-radius: 8px;
        box-shadow: 1px 1px 3px var(--ThemeColor);
        -webkit-box-shadow: 1px 1px 3px var(--ThemeColor);
      }
      .conCenter{
        display:inline-block;
        height: 98%;
        overflow-x:hidden;
        overflow-y:auto;
      }
    }
  }
}
</style>